import Scorocode from './Scorocode'

// export { Greeter } from './Greeter'

// const Scorocode = require('sdk');

// const app = Scorocode.app({ /* config */ }, 'DEFAULT');
// app.client();

export default new Scorocode()
